class VwVezneKullanicimapDTO {
    id?: number = 0;
    fkGnlKullanici?: number = null;
    fkVezneTanim?: number = null;
    eklemeKullanici?: number = null;
    eklemeTarihi?: string = null;
    vezneAdi?: string = "";
    organizasyonId?: number = null;
    seriNo?: string = "";
    kalinanNo?: number = null;
    fkVeznePoscihaztanim?: number = null;
    oncekiKasaKapamaUyari?: number = null;
    organizasyonAdi?: string = "";
    bagliId?: number = null;
    treekey?: string = "";
    posAdi?: string = "";
    yetkili?: string = "";
}
export default VwVezneKullanicimapDTO;